import React from "react";
import { FormGroup, FormText, Label, Container, Row, Col } from "reactstrap";
import s from "./tabTokenization.scss";
import { Styled } from "../../../../toolkit/decorators/Artifact";

export interface Props {
  paymentMethod: any;
}

@Styled(s)
class PaymentMethodItem extends React.Component<Props> {
  render() {
    return (
      <div style={{ marginLeft: "24px" }}>
        <div
          style={{
            fontWeight: "bold",
            fontSize: "14px",
            marginBottom: "10px"
          }}
        >
          Medio de pago {this.props.paymentMethod.principal ? "principal" : ""}
        </div>
        <div className={`${s.infoCard} ${s.bquote}`}>
          <FormGroup>
            <Label style={{ fontWeight: "bold" }}>Titular:</Label>
            <FormText color="muted">
              {(this.props.paymentMethod || {}).nombreTitular || ""}
            </FormText>
          </FormGroup>
          <FormGroup>
            <Label style={{ fontWeight: "bold" }}>Tipo:</Label>
            <FormText color="muted">
              {(this.props.paymentMethod || {}).tipoMedioPago || ""}
            </FormText>
          </FormGroup>
          <FormGroup>
            <Label style={{ fontWeight: "bold" }}>Emisor:</Label>
            <FormText color="muted">
              {(this.props.paymentMethod || {}).tipoTarjeta || ""}
            </FormText>
          </FormGroup>
          <FormGroup>
            <Label style={{ fontWeight: "bold" }}>Número:</Label>
            <FormText color="muted">
              {(this.props.paymentMethod || {}).numero || ""}
            </FormText>
          </FormGroup>
          <FormGroup>
            <Label style={{ fontWeight: "bold" }}>Fecha vencimiento:</Label>
            <FormText color="muted">
              {(this.props.paymentMethod || {}).fechaVencimiento || ""}
            </FormText>
          </FormGroup>
        </div>
      </div>
    );
  }
}

export default PaymentMethodItem;
